import * as React from 'react';

import Button from '../../Button';
import {DropdownMenu} from '../../DropdownMenu';
import {Modal} from '../../Modal';
import './PostcardCreatorModal.css';
import {IDropdownMenuOption} from "../../DropdownMenu/DropdownMenu";
import {ImageFileTypes} from "../../../infrastructure/ImageFileTypes";

export interface PostcardCreatorProps {
  show: any;
  onClose: any;
  onSubmit(iconName: string, postcardSide: string, formData: FormData): void;
}

export interface PostcardCreatorState {
  iconName: string;
  postcardSide: string,
  imageFormData: FormData;
  hasRequiredFields: boolean;
}

export default class PostcardCreatorModal extends React.Component<PostcardCreatorProps, PostcardCreatorState> {

  constructor(props: PostcardCreatorProps) {
    super(props);
    this.state = {
      iconName: "",
      postcardSide: "",
      imageFormData: new FormData(),
      hasRequiredFields: false
    };
  }

  closeModal() {
      this.setState({
      });
      this.props.onClose();
  }

  checkForValidInput() {
    this.setState({
      hasRequiredFields:
        this.state.iconName.length > 0
        && (this.state.postcardSide.length > 0)
        && this.state.imageFormData.get(ImageFileTypes.POSTCARD_IMAGE) != null
    });
  }

  handleNameChange(text: string) {
    this.setState({
      iconName: text
    }, () => this.checkForValidInput());
  }

  handleSideTypeChange(text: string) {
      this.setState({
          postcardSide: text
      }, () => this.checkForValidInput());
  }

  handleImageChange(imageId: string, selectorFiles: FileList | null)
  {
    if (selectorFiles != null) {
      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          var imageFormData = this.state.imageFormData
          imageFormData.set(imageId, selectorFiles[key]);
          this.setState({
            imageFormData: imageFormData
          }, () => this.checkForValidInput());
          break;
        }
      }
    }
  }

  render() {

      const postcardSides: string[] = ["Front", "Back"];
      const postcardSideOptionsList: IDropdownMenuOption[] = postcardSides.map((side) => (
          {
              title: side,
              onClick: () => {
                  this.handleSideTypeChange(side);
              }
          })
      );

    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <div className="coverModalHeaderContainer">
                  <div>
                    <Modal.Title>
                        <h5>
                            {'Upload Postcard Images'}
                        </h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
                  </div>
                  <div>
                      All Images Must Be JPEGs
                  </div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="coverInputContainer">
                    <label>
                        Postcard Image Name (ex: "Seed X")
                    </label>
                  <input
                    className="coverModelInput"
                    type="text"
                    value={this.state.iconName}
                    onChange={(event) => this.handleNameChange(event.target.value)}
                  />
                </div>
                <div className="coverInputContainer">
                    <div>
                        <label>
                            Postcard Side:
                        </label>
                    </div>
                    <div className="coverModelInput">
                        <DropdownMenu
                            title={(this.state.postcardSide.length > 0) ? this.state.postcardSide : ""}
                            options={postcardSideOptionsList}
                            extraWide={false}
                        />
                    </div>
                </div>
                <div className="coverInputContainer">
                    <label>
                        Postcard Image (6"x9" 1800x2700 pixels)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.POSTCARD_IMAGE, e.target.files)} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                        if ((this.state.iconName.length > 0) && (this.state.postcardSide.length > 0)) {
                            this.props.onSubmit(this.state.iconName, this.state.postcardSide, this.state.imageFormData);
                            this.setState({
                                iconName: "",
                                postcardSide: "",
                                imageFormData: new FormData(),
                                hasRequiredFields: false
                                },);
                            }
                        }
                    }
                >
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/PostcardCreatorModal/PostcardCreatorModal.tsx